module.exports = __webpack_public_path__ + "img/accept-left-circle1.67f03724.svg";